export interface IPauseIconProps {
	size?: number;
	color?: string;
}

export function PauseIcon({
	size = 24,
	color = 'currentColor',
}: IPauseIconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.96478 8.12566C10.4179 8.12578 10.7854 8.4933 10.7855 8.94637V15.0547C10.7853 15.5077 10.4178 15.8753 9.96478 15.8754C9.51168 15.8754 9.1443 15.5077 9.14407 15.0547V8.94637C9.14418 8.49323 9.51161 8.12566 9.96478 8.12566Z"
				fill={color}
			/>
			<path
				d="M14.0363 8.12566C14.4893 8.12581 14.8569 8.49332 14.857 8.94637V15.0547C14.8568 15.5077 14.4893 15.8753 14.0363 15.8754C13.5832 15.8754 13.2158 15.5077 13.2156 15.0547V8.94637C13.2157 8.49323 13.5831 8.12566 14.0363 8.12566Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9995 1C18.0742 1 22.9995 5.92483 23 11.9995C23 18.0746 18.0746 23 11.9995 23C5.92483 22.9995 1 18.0742 1 11.9995C1.00054 5.92516 5.92516 1.00054 11.9995 1ZM11.9995 2.64142C6.83165 2.64197 2.64197 6.83165 2.64142 11.9995C2.64142 17.1677 6.83131 21.358 11.9995 21.3586C17.1681 21.3586 21.3586 17.1681 21.3586 11.9995C21.358 6.83131 17.1677 2.64142 11.9995 2.64142Z"
				fill={color}
			/>
		</svg>
	);
}
